<template>
    <v-container>
        <v-row>
            <v-col/>
            <v-col cols="auto">
                <v-spacer/>
                <v-btn icon
                       :color="color"
                       :disabled="selection === 'all' || readonly"
                       @click="selectAll">
                    <v-icon>mdi-select-all</v-icon>
                </v-btn>
                <v-btn icon
                       :color="color"
                       :disabled="selection === 'none' || readonly"
                       @click="deselectAll">
                    <v-icon>mdi-select-off</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-autocomplete label="Apps"
                                :items="apps"
                                :value="selectedApps"
                                @change="updateSelectedApps($event)"
                                item-text="name"
                                item-value="id"
                                :loading="isLoading"
                                :readonly="readonly"
                                multiple chips/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "NotificationApps",
    props: {
        color: {
            type: String,
            default: "primary"
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        selectedApps: {
            type: Array,
            default: () => [],
        }
    },
    model: {
        event: 'change',
        prop: 'selectedApps'
    },
    mounted() {
        if (!this.appsLoaded) {
            this.loadApps();
        }
    },
    computed: {
        ...mapState('app', [
            'apps',
            'isLoading'
        ]),
        ...mapGetters('app', [
            'appsLoaded',
        ]),
        selectedItems: {
            get() {
                if (!this.appsLoaded)
                    return [];
                let selectedItems = [];
                this.apps.forEach((app, index) => {
                    if (this.selectedApps.map(app => app.id).includes(app.id)) {
                        selectedItems.push(index);
                    }
                });
                return selectedItems;
            },
            set(value) {
                this.updateSelectedApps(value);
            }
        },
        selection() {
            if (!this.appsLoaded)
                return 'none';
            if (this.selectedItems.length === this.apps.length) {
                return "all";
            } else if (this.selectedItems.length === 0) {
                return "none";
            } else {
                return "partial";
            }

        }
    },
    methods: {
        ...mapActions('app', [
            'loadApps'
        ]),
        selectAll() {
            this.$emit('change', [...this.apps]);
        },
        deselectAll() {
            this.selectedItems = [];
        },
        updateSelectedApps(items) {
            this.$emit('change', items.map(app_id => ({id: app_id})));
        }
    }
}
</script>

<style scoped>

</style>
